import { toast } from "react-hot-toast"
import { endpoints } from "../apis"
import { setLoading, setToken } from "../../slices/authSlice"
import { setUser } from "../../slices/profileSlice"
import { apiConnector } from "../apiconnector";

const { SENDOTP_API, SIGNUP_API, LOGIN_API, RESETPASSTOKEN_API, RESETPASSWORD_API } = endpoints;

export function sendOtp(email, navigate) {
    return async (dispatch) => {
        const toastId = toast.loading("Loading...");
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", SENDOTP_API, { email });
            console.log("send otp response: ", response);

            if (!response.data.success) {
                throw new Error(response.data.message);
            }

            toast.success("OTP Sent Successfully");
            navigate("/verify-email");
        } catch (error) {
            console.log("failed to send otp", error);
            toast.error(`Could Not Send OTP, ${error.response.data.message}`);
        }
        toast.dismiss(toastId);
        dispatch(setLoading(false));
    }
}

export function signUp(accountType, firstName, lastName, email, password, confirmPassword, otp, navigate) {
    return async (dispatch) => {
        const toastId = toast.loading("Loading...");
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", SIGNUP_API, { accountType, firstName, lastName, email, password, confirmPassword, otp, navigate });
            console.log("SIGNUP API RESPONSE: ", response);

            if (!response.data.success) {
                throw new Error(response.data.message);
            }

            toast.success("Signup Successful");
            navigate("/login");
        } catch (error) {
            console.log("failed to signup", error);
            toast.error(`Signup Failed, ${error.response.data.message}`);
            navigate("/signup");
        }
        toast.dismiss(toastId);
        dispatch(setLoading(false));
    }
}

export function login(email, password, navigate) {
    return async (dispatch) => {
        const toastId = toast.loading("Loading...");
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", LOGIN_API, { email, password });

            console.log("LOGIN API RESPONSE............", response)
            if (!response.data.success) {
                throw new Error(response.data.message);
            }

            toast.success("Login Successfull");
            dispatch(setToken(response.data.token));
            dispatch(setUser(response.data.user));
            localStorage.setItem("token", JSON.stringify(response.data.token));
            localStorage.setItem("user", JSON.stringify(response.data.user));
            navigate("/dashboard/my-profile");
        } catch (error) {
            console.log("LOGIN API ERROR............", error);
            toast.error(`Login Failed, ${error.response.data.message}`);
        }
        dispatch(setLoading(false));
        toast.dismiss(toastId);
    }
}

export function getPasswordResetToken(email, setEmailSent) {
    return async (dispatch) => {
        const toastId = toast.loading("Loading...");
        dispatch(setLoading(true));
        try {
            const response = await apiConnector("POST", RESETPASSTOKEN_API, { email });
            console.log("RESETPASSTOKEN RESPONSE............", response);
            if (!response.data.success) {
                throw new Error(response.data.message);
            }

            toast.success("Reset Email Sent");
            setEmailSent(true);
        } catch (error) {
            console.log("RESETPASSTOKEN ERROR............", error);
            toast.error(`Failed To Send Reset Email, ${error.response.data.message}`);
        }

        toast.dismiss(toastId);
        dispatch(setLoading(false));
    }
}

export function resetPassword(password, confirmPassword, token, navigate) {
    return async (dispatch) => {
        dispatch(setLoading(true));
        const toastId = toast.loading("Loading...");
        try {
            const response = await apiConnector("POST", RESETPASSWORD_API, {
                password,
                confirmPassword,
                token
            });

            console.log("Reset Password response:", response);
            if (!response.data) {
                throw new Error(response.data.message);
            }

            toast.success("Password updated successfully");
            navigate("/login");
        } catch (error) {
            toast.error(`Failed to reset password, ${error.response.data.message}`);
            console.log("Reset password error", error);
        }
        toast.dismiss(toastId);
        dispatch(setLoading(false));
    }
}

export function logout(navigate) {
    return async (dispatch) => {
        dispatch(setToken(null));
        dispatch(setUser(null));
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("cart");
        toast.success("Logged Out successfully");
        navigate("/");
    }
}